// extracted by mini-css-extract-plugin
module.exports = {"group_name":"group_name-GopdV","arrow_icon":"arrow_icon-Ifsjz"};